import useUserUiPreferenceStorageValue from "./useUserUiPreferenceStorageValue.js";
import React from "react";

import {
  persistDataManagerTableSortState,
  resolveDataManagerTableSortState,
} from "../utils/dataManagerTableSortStorage.js";

export default function useDataManagerTableSortState(tableKey, resolveFallbackSortState) {
  const [sortState, setSortState] = React.useState(() => (
    resolveDataManagerTableSortState(tableKey, resolveFallbackSortState())
  ));

  const storedSort = useUserUiPreferenceStorageValue("session", "grain-saas:data-manager:table-sort:v1");
  React.useEffect(() => {
    const next = resolveDataManagerTableSortState(tableKey, resolveFallbackSortState());
    setSortState((current) => current.key === next.key && current.direction === next.direction ? current : next);
  }, [storedSort, tableKey]);

  React.useEffect(() => {
    persistDataManagerTableSortState(tableKey, sortState);
  }, [sortState, tableKey]);

  return [sortState, setSortState];
}
